import { createReducer, on } from '@ngrx/store';
import * as UserActions from './user.actions';
import { UserState } from './user.state';
import { login } from './user.actions';
import { IUser } from '../model/user.model';

export const initialUserState: UserState = {
    isAuthenticated: false,
    user: {} as IUser,
    authenticationError: undefined,
    retryLoginError: undefined,
    routeToNavigate: undefined
};
 
export const userReducer = createReducer(
    initialUserState,

    on (login, (state , { user }) => ({       
      ...state, 
      isAuthenticated: false,
      routeToNavigate: state.routeToNavigate,
      user: user, 
      authenticationError: undefined 
    })),

    on (UserActions.loginSuccess, (state, { user }) => ({ 
      ...state, 
      user: user, 
      routeToNavigate: state.routeToNavigate,
      isAuthenticated: true, 
      authenticationError: undefined,
     }
    )),

    on (UserActions.loginFailure, (state, { error }) => ({ 
      ...state, 
      isAuthenticated: false, 
      user: {} as IUser, 
      authenticationError: error 
    })),
    
    on (UserActions.retryLoginFailure, (state, { error }) => (
        {
          ...state, 
          isAuthenticated: false, 
          user: {} as IUser, 
          retryLoginError: error 
        })),

    on (UserActions.logout, () => { return initialUserState; }),
    on (UserActions.logoutTimeout, () => { return initialUserState; }),
    on (UserActions.setUser, (state, { user }) => ({ ...state, user })),
    on (UserActions.userRegister, (state ) => ({ ...state})),
    on (UserActions.userRegisterSuccess, (state) => ({ ...state })),
    on (UserActions.updatePictureSuccess, (state , { imageUrl }) => ({ 
      ...state, 
      user: {...state.user, pictureUrl: imageUrl}
    })),  

    on (UserActions.updateGeneralDataSuccess, (state , { name, email, login }) => ({ 
      ...state, 
      user: {...state.user, name: name, email:email, login:login}
    })),

    on (UserActions.updateGeneralSettingsSuccess, (state , { timeout, publicProfile }) => ({ 
      ...state, 
      user: {...state.user, timeout: +timeout, publicProfile: publicProfile}
    })),

    on (UserActions.updateRouteToNavigate, (state , { route, productId }) => ({ 
      ...state, 
      routeToNavigate: route,
      productToAddToCart: productId
    })),

    on (UserActions.clearRouteToNavigateSuccess, (state , _) => ({ 
      ...state, 
      routeToNavigate: undefined,
      productToAddToCart: undefined
    }))    
);
